export const GLOBAL__MUTATIONS = {
  SET_IS_LOADING: "SET_IS_LOADING",
  SET_COMMON_ERRORS: "SET_COMMON_ERRORS",
};

export const ADMINNOTIFICATION__MUTATIONS = {
  ADMINGETNOTIFICATION: "ADMINGETNOTIFICATION",
  ADMINCREATENOTIFICATION: "ADMINCREATENOTIFICATION",
  ADMINUPDATENOTIFICATION: "ADMINUPDATENOTIFICATION",
  ADMINMARKASREADNOTIFICATION: "ADMINMARKASREADNOTIFICATION",
  SET_POLLING_INTERVAL: "SET_POLLING_INTERVAL",
  STOP_POLLING_INTERVAL: "STOP_POLLING_INTERVAL",
  ADDCLIENTNOTIFICATION: "ADDCLIENTNOTIFICATION"
};

export const DASHBOARDAPIREQ__MUTATIONS = {
  TOTALPARTNERS: "TOTALPARTNERS",
  TOTALLIVEACCOUNTS: "TOTALLIVEACCOUNTS",
};

export const COMPANYINFO__MUTATIONS = {
  COMPANYINFO: "COMPANYINFO",
  LOGINPAGEINFO: "LOGINPAGEINFO",
};

export const MODAL__MUTATIONS = {
  SET_IS_OPEN: "SET_IS_OPEN",
};


export const AGREEMENTS__MUTATIONS = {
  CREATEAGREEMENT: "CREATEAGREEMENT",
  GETPARTNERSAGREEMENTSHISTORIES: "GETPARTNERSAGREEMENTSHISTORIES",
  GETCLIENTSAGREEMENTSHISTORIES: "GETCLIENTSAGREEMENTSHISTORIES",
  UPDATECLIENTSAGREEMENTSTATUS: "UPDATECLIENTSAGREEMENTSTATUS",
  GETTRADINGAGREEMENTS: "GETTRADINGAGREEMENTS",
  GETOTHERSAGREEMENTS: "GETOTHERSAGREEMENTS",
  GETIBAGREEMENTS: "GETIBAGREEMENTS",
  ACCEPTEDAGREEMENTS: "ACCEPTEDAGREEMENTS",
  NOTACCEPTEDAGREEMENTS: "NOTACCEPTEDAGREEMENTS",
};

export const LOGOUT__DIALOG__MUTATIONS = {
  SHOW_DIALOG: "SHOW_DIALOG",
  HIDE_DIALOG: "HIDE_DIALOG",
};

export const ALLNEWUSER__MUTATIONS = {
  INSERTNEWUSER: "INSERTNEWUSER",
  REMOVENEWUSER: "REMOVENEWUSER",
  GETALLPARTNERS: "GETALLPARTNERS",
  GETALLCLIENTS: "GETALLCLIENTS",
};

export const AUTHENTICATION__MUTATIONS = {
  TOKEN: "TOKEN",
  REMOVE_TOKEN: "REMOVE_TOKEN",
  GETTIME: "GETTIME",
  SET_ACTIVE_SESSION: "SET_ACTIVE_SESSION",
  CLEAR_ACTIVE_SESSION: "CLEAR_ACTIVE_SESSION"
};

export const REGISTEREDUSER__MUTATIONS = {
  REGISTEREDUSER: "REGISTEREDUSER",
  TABLEOPTIONS: "TABLEOPTIONS",
  DASHBOARDREGISTEREDUSERS: "DASHBOARDREGISTEREDUSERS",
  DASHBOARDTOTALUSERS: "DASHBOARDTOTALUSERS",
  ALLREGISTEREDUSERUSER: "ALLREGISTEREDUSERUSER",
};

export const COUNTRIES__MUTATIONS = {
  COUNTRIES: "COUNTRIES",
};

export const CITIES__MUTATIONS = {
  CITIES: "CITIES",
};

export const STATES__MUTATIONS = {
  STATES: "STATES",
};

export const NEWUSER__MUTATIONS = {
  NEWUSER: "NEWUSER",
};

export const PARTNERPAYMENTMETHOD__MUTATIONS = {
  PARTNER_PAYMENT_METHODS: "PARTNER_PAYMENT_METHODS",
  CREATE_PARTNER_PAYMENT_METHOD: "CREATE_PARTNER_PAYMENT_METHOD",
  EDIT_PARTNER_PAYMENT_METHOD: "EDIT_PARTNER_PAYMENT_METHOD",
  DELETE_PARTNER_PAYMENT_METHOD: "DELETE_PARTNER_PAYMENT_METHOD",
};

export const CLIENTS_DOCUMENTS__MUTATIONS = {
  CLIENTS_DOCUMENTS: "CLIENTS_DOCUMENTS",
  UPLOAD_DOCUMENTS: "UPLOAD_DOCUMENTS",
};

export const PROFILE__MUTATIONS = {
  PROFILE: "PROFILE",
  IDENTITYVERIFICATION: "IDENTITYVERIFICATION",
  RESIDENCEVERIFICATION: "RESIDENCEVERIFICATION",
  IDENTITYVERIFICATIONDOCUMENTS: "IDENTITYVERIFICATIONDOCUMENTS",
  RESIDENCEVERIFICATIONDOCUMENTS: "RESIDENCEVERIFICATIONDOCUMENTS",
  BUSINESSAMOUNT: "BUSINESSAMOUNT",
};

export const BLOCKEDUSER__MUTATIONS = {
  BLOCKEDUSER: "BLOCKEDUSER",
};

export const DEMOACCOUNTS__MUTATIONS = {
  DEMOACCOUNTS: "DEMOACCOUNTS",
};

export const TESTINGACCOUNTS__MUTATIONS = {
  TESTINGACCOUNTS: "TESTINGACCOUNTS",
  CREATETESTINGACCOUNT: "CREATETESTINGACCOUNT",
};

export const LIVEACCOUNTS__MUTATIONS = {
  LIVEACCOUNTS: "LIVEACCOUNTS",
};

// low balance and inactive accounts mutations
export const INACTIVEACCOUNTS__MUTATIONS = {
  INACTIVEACCOUNTS: "INACTIVEACCOUNTS",
};
export const LOWBALANCEACCOUNTS__MUTATIONS = {
  LOWBALANCEACCOUNTS: "LOWBALANCEACCOUNTS",
};

export const ACCOUNTTYPES__MUTATIONS = {
  ACCOUNTTYPES: "ACCOUNTTYPES",
};

export const USERLOGINACTIVITY__MUTATIONS = {
  USERLOGINACTIVITY: "USERLOGINACTIVITY",
};

export const MARKETTINGTOOLS__MUTATIONS = {
  BANNERCATEGORIES: "BANNERCATEGORIES",
  BANNERSIZES: "BANNERSIZES",
  BANNERS: "BANNERS",
  CREATEBANNER: "CREATEBANNER",
  UPDATEBANNER: "UPDATEBANNER",
  DELETEBANNER: "DELETEBANNER",
  BANNERSIZECREATE: "BANNERSIZECREATE",
  BANNERSIZEUPDATE: "BANNERSIZEUPDATE",
  BANNERSIZEDELETE: "BANNERSIZEDELETE",
};

export const CURRENCY__MUTATIONS = {
  ACTIVECURRENCIES: "ACTIVECURRENCIES",
  UPDATECURRENCYSYMBOL: "UPDATECURRENCYSYMBOL",
  ACTIVECURRENCYGROUPS: "ACTIVECURRENCYGROUPS",
  UPDATECURRENCYGROUP: "UPDATECURRENCYGROUP",
  GETCURRECNCYUSDT: "GETCURRECNCYUSDT",
  UPDTECURRENCYUSDT: "UPDTECURRENCYUSDT"
};


export const COMMISSIONSETTINGS__MUTATIONS = {
  COMMISSIONSETTINGS: "COMMISSIONSETTINGS",
};

export const PARTNERWITHDRAW__MUTATIONS = {
  DASHBOARDPARTNERWITHDRAW: "DASHBOARDPARTNERWITHDRAW",
  PARTNERWITHDRAW: "PARTNERWITHDRAW",
  FILTERPARTNERWITHDRAW: "FILTERPARTNERWITHDRAW",
};

export const LIVETRADES__MUTATIONS = {
  LIVETRADES: "LIVETRADES",
  DASHBOARDLIVETRADES: "DASHBOARDLIVETRADES",
  LIVETRADESCHARTDATA: "LIVETRADESCHARTDATA"
};

export const USERLIVETRADES__MUTATIONS = {
  USERLIVETRADES: "USERLIVETRADES",
};

export const CLOSEDTRADES__MUTATIONS = {
  CLOSEDTRADES: "CLOSEDTRADES",
  DASHBOARDCLOSEDTRADES: "DASHBOARDCLOSEDTRADES",
  CLOSEDTRADESCHARTDATA: "CLOSEDTRADESCHARTDATA"
};

export const SHORTDURATIONTRADES__MUTATIONS = {
  SHORTDURATIONTRADES: "SHORTDURATIONTRADES",
  // DASHBOARDSMALLTRADES: "DASHBOARDSMALLTRADES",
};

export const USERCLOSEDTRADES__MUTATIONS = {
  USERCLOSEDTRADES: "USERCLOSEDTRADES",
};

export const TRANSACTIONS__MUTATIONS = {
  TRXSUMMARIES: "TRXSUMMARIES",
  TRXSUMMARIESEXCEL: "TRXSUMMARIESEXCEL",
  TRXDEPOSITS: "TRXDEPOSITS",
  TRXWITHDRAWAL: "TRXWITHDRAWAL",
  TRXDASHBOARDDEPOSITS: "TRXDASHBOARDDEPOSITS",
  TRXDASHBOARDWITHDRAWAL: "TRXDASHBOARDWITHDRAWAL",
  TRXINTERNALTRANSFER: "TRXINTERNALTRANSFER",
  TRXDASHBOARDINTERNALTRANSFER: "TRXDASHBOARDINTERNALTRANSFER",
  TRXCREDITIN: "TRXCREDITIN",
  TRXCREDITOUT: "TRXCREDITOUT",
  TRXDEPOSITEXCEL: "TRXDEPOSITEXCEL",
  TRXWITHDRAWALEXCEL: "TRXWITHDRAWALEXCEL",
};

export const RMSSETTINGS__MUTATIONS = {
  RMSSETTINGS: "RMSSETTINGS",
  RMSGRAPH: "RMSGRAPH",
  PROFITREACHES: "PROFITREACHES",
  AUTOCREDITBACK: "AUTOCREDITBACK",
  UPDATEPROFITREACHES: "UPDATEPROFITREACHES",
  UPDATERMSSETTINGS: "UPDATERMSSETTINGS",
};

export const NEWS__MUTATIONS = {
  GETNEWS: "GETNEWS",
  NEWSCATEGORIES: "NEWSCATEGORIES",
  SINGLENEWS: "SINGLENEWS",
};

export const TICKETS__MUTATIONS = {
  MESSAGES: "MESSAGES",
  REPLY: "REPLY",
  TOGGLE_TICKET: "TOGGLE_TICKET",
  DELETECOMMENT: "DELETECOMMENT",
  UPDATECOMMENT: "UPDATECOMMENT",
  MARKSEEN: "MARKSEEN",
};

export const MARKETINGDATA__MUTATIONS = {
  GETMARKETINGUSERS: "GETMARKETINGUSERS",
  GETALLEMAIL: "GETALLEMAIL",
  GETEMAILSBYCATEGORY: "GETEMAILSBYCATEGORY",
};

export const SERVERCONFIG__MUTATIONS = {
  SERVERCONFIG: "SERVERCONFIG",
};

export const EMAILCONFIG__MUTATIONS = {
  EMAILCONFIG: "EMAILCONFIG",
};

export const LEVERAGE__MUTATIONS = {
  LEVERAGE: "LEVERAGE",
  USERLEVERAGE: "USERLEVERAGE",
};

export const GENERALINFO__MUTATIONS = {
  GENERALINFO: "GENERALINFO",
  UPDATEGENERALINFOLOGO: "UPDATEGENERALINFOLOGO",
};

export const ACCGROUPS__MUTATIONS = {
  ACCGROUPS: "ACCGROUPS",
  USERACCGROUPS: "USERACCGROUPS",
  UPDATEUSERACCGROUPS: "UPDATEUSERACCGROUPS",
  CREATEACCGROUPS: "CREATEACCGROUPS",
  UPDATEACCGROUPS: "UPDATEACCGROUPS",
  DELETEACCGROUPS: "DELETEACCGROUPS",
  GETCURRENCIESGROUP: "GETCURRENCIESGROUP",
};

export const BROKERSBANK__MUTATIONS = {
  GETBROKERSBANK: "GETBROKERSBANK",
  GETCURRENCIES: "GETCURRENCIES",
};

export const CRYPTOADDRESS__MUTATIONS = {
  GETCRYPTOADDRESS: "GETCRYPTOADDRESS",
  CREATECRYPTOADDRESS: "CREATECRYPTOADDRESS",
  UPDATECRYPTOADDRESS: "UPDATECRYPTOADDRESS",
};

export const ADMINS__MUTATIONS = {
  GETADMINS: "GETADMINS",
  GETADMIN: "GETADMIN",
  GETROLES: "GETROLES",
  CREATEADMIN: "CREATEADMIN",
  UPDATEADMIN: "UPDATEADMIN",
  GETLOGINACTIVITIES: "GETLOGINACTIVITIES",
  CREATEPERMISSION: "CREATEPERMISSION",
  GETALLMODULES: "GETALLMODULES",
};

export const REGISTERUSERDETAILS__MUTATIONS = {
  REGPERSONALINFO: "REGPERSONALINFO",
  ACCOUNTDESCENDANTS: "ACCOUNTDESCENDANTS",
  UPDATEREGPERSONALINFO: "UPDATEREGPERSONALINFO",
  CLIENTDEPOSITS: "CLIENTDEPOSITS",
  CLIENTWITHDRAWS: "CLIENTWITHDRAWS",
  CLIENTINTTRXS: "CLIENTINTTRXS",
  CLIENTCREDITINOUT: "CLIENTCREDITINOUT",
  CLIENTMT5ACCOUNTANDTYPES: "CLIENTMT5ACCOUNTANDTYPES",
  CHANGECLIENTLEVERAGE: "CHANGECLIENTLEVERAGE",
  USERTRADINGACCOUNTS: "USERTRADINGACCOUNTS",
  CLIENTTRADINGACCOUNTS: "CLIENTTRADINGACCOUNTS",
  PAYMENTSYSTEMFORDEPOSIT: "PAYMENTSYSTEMFORDEPOSIT",
  PAYMENTSYSTEMFORWITHDRAW: "PAYMENTSYSTEMFORWITHDRAW",
  CREATECLIENTDEPOSIT: "CREATECLIENTDEPOSIT",
  GETMANAGERS: "GETMANAGERS",
  USERDEMOACCOUNTS: "USERDEMOACCOUNTS",
  USERDOCUMENTS: "USERDOCUMENTS",
  BROKERSBANK: "BROKERSBANK",
  CREATELIVEACCOUNT: "CREATELIVEACCOUNT",
  CREATEDEMOACCOUNT: "CREATEDEMOACCOUNT",
  UPDATEMT5ACCOUNT: "UPDATEMT5ACCOUNT",
};

export const CLIENTBANKS__MUTATIONS = {
  CLIENTBANKS: "CLIENTBANKS",
  CLIENTCRYPTOS: "CLIENTCRYPTOS",
  CREATECLIENTCRYPTO: "CREATECLIENTCRYPTO",
}

export const MAM__MUTATIONS = {
  GETALLMAM: "GETALLMAM",
  GETALLPAMM: "GETALLPAMM",
  GETALLINVESTORS: "GETALLINVESTORS",
  GETALLCOPYTRADE: "GETALLCOPYTRADE",
  GETMONTHLYTRADES: "GETMONTHLYTRADES",
  GETWEEKLYTRADES: "GETWEEKLYTRADES",
  GETTOPTRADESBYSYMBOL: "GETTOPTRADESBYSYMBOL",
  GETMANAGERPROFITLOSS: "GETMANAGERPROFITLOSS",
  GETMAMMANAGERSTATISTICS: "GETMAMMANAGERSTATISTICS",
  GETMAMMANAGERINVESTORS: "GETMAMMANAGERINVESTORS",
  CHANGEINVESTORSTATUS: "CHANGEINVESTORSTATUS",
  CHANGEMANAGERSTATUS: "CHANGEMANAGERSTATUS",
  REMOVEINVESTOR: "REMOVEINVESTOR",
  GETLIVEORDERS: "GETLIVEORDERS",
  GETREPORTS: "GETREPORTS",
  COMMISSIONSTAB: "COMMISSIONSTAB",
  COMMISSIONSHISTORYTAB: "COMMISSIONSHISTORYTAB",
  UPDATEINVESTORCOMMISSION: "UPDATEINVESTORCOMMISSION",
}

export const TRADEMASTER__MUTATIONS = {
  GETALLMANAGER: "GETALLMANAGER",
  GETRADEMASTERINVESTORSTATISTICS: "GETRADEMASTERINVESTORSTATISTICS",
  GETINVESTORCLIENTS: "GETINVESTORCLIENTS"
}

export const CONTEST__MUTATIONS = {
  GETCONTEST: "GETCONTEST",
  GETALLCONTEST: "GETALLCONTEST",
  GETALLUPCOMINGCONTEST: "GETALLUPCOMINGCONTEST",
  GETALLRUNNINGCONTEST: "GETALLRUNNINGCONTEST",
  GETALLFINISHEDCONTEST: "GETALLFINISHEDCONTEST",
  GETALLCONTESTACCTYPES: "GETALLCONTESTACCTYPES",
  UPDATECONTEST: "UPDATECONTEST",
  VIEWFINISHEDCONTEST: "VIEWFINISHEDCONTEST",
  VIEWRUNNINGCONTEST: "VIEWRUNNINGCONTEST",
  VIEWUPCOMINGCONTEST: "VIEWUPCOMINGCONTEST",
  APPROVEDPARTICIPANTS: "APPROVEDPARTICIPANTS",
  PENDINGPARTICIPANTS: "PENDINGPARTICIPANTS",
  ALLUPCOMINGPARTICIPANTS: "ALLUPCOMINGPARTICIPANTS",
  ALLRUNNINGPARTICIPANTS: "ALLRUNNINGPARTICIPANTS",
  ALLFINISHEDPARTICIPANTS: "ALLFINISHEDPARTICIPANTS",
  UPDATECONTESTANTSTATUS: "UPDATECONTESTANTSTATUS",
  CREATECONTEST: "CREATECONTEST",
}


export const COMMISSIONTREE__MUTATIONS = {
  GETCOMMISSIONSETTINGS: "GETCOMMISSIONSETTINGS",
  SPLITTOTALCOMMISSION: "SPLITTOTALCOMMISSION",
  ADDCOMMISSIONSETTINGSCONFIG: "ADDCOMMISSIONSETTINGSCONFIG",
  ALLCOMMISSIONTREES: "ALLCOMMISSIONTREES",
  VIEWCOMMISSION: "VIEWCOMMISSION",
}

export const IBREQUEST__MUTATIONS = {
  ALLPENDINGIBREQUEST: "ALLPENDINGIBREQUEST",
  ALLREJECTEDIBREQUEST: "ALLREJECTEDIBREQUEST",
  LATESTIBREQUEST: "LATESTIBREQUEST",
  TOPIBDETAILS: "TOPIBDETAILS",
  TOPIBDETAILSFILTER: "TOPIBDETAILSFILTER",
  ALLTOPPERFORMEDIB: "ALLTOPPERFORMEDIB",
}

export const LOTCHART__MUTATIONS = {
  TRADINGLOTCHART: "TRADINGLOTCHART",
}

export const PARTNERLIST__MUTATIONS = {
  PARTNERLIST: "PARTNERLIST",
  DASHBOARDIBREQUEST: "DASHBOARDIBREQUEST",
  ALLPARTNERLIST: "ALLPARTNERLIST",
  DASHBOARDPARTNERLISTS: "DASHBOARDPARTNERLISTS",
  CLIENTTREE: "CLIENTTREE",
  PARTNERSUMMARY: "PARTNERSUMMARY",
  COMMISSIONHISTORY: "COMMISSIONHISTORY",
  WITHDRAWALS: "WITHDRAWALS",
  ADVANCEDRATES: "ADVANCEDRATES",
  ADVANCEDRATESCOMMISSIONTREE: "ADVANCEDRATESCOMMISSIONTREE",
  UPDATECOMMISSIONRATES: "UPDATECOMMISSIONRATES",
  UPDATECOMMISSIONSTATUS: "UPDATECOMMISSIONSTATUS",
  ADDCLIENTLEVELONE: "ADDCLIENTLEVELONE",
  IBWITHDRAWAL: "IBWITHDRAWAL",
};

export const ASSIGNACCTYPE__MUTATIONS = {
  ALLMASTERIB: "ALLMASTERIB",
  MASTERIBDATATABLE: "MASTERIBDATATABLE",
  UNIQUECOUNTRIES: "UNIQUECOUNTRIES",
  ASSIGNSINGLEIB: "ASSIGNSINGLEIB",
};

export const LEVELUNLOCKSETTINGS__MUTATIONS = {
  LEVELUNLOCKSETTINGS: "LEVELUNLOCKSETTINGS",
  POSTLEVELUNLOCKSETTINGS: "POSTLEVELUNLOCKSETTINGS",
  POSTPARTNERLEVELUNLOCKSETTINGS: "POSTPARTNERLEVELUNLOCKSETTINGS",
  PARTNERLEVELUNLOCKSETTINGS: "PARTNERLEVELUNLOCKSETTINGS",
};

export const TRADABLEBONUS__MUTATIONS = {
  TRADABLEBONUSHISTORY: "TRADABLEBONUSHISTORY",
  DIRECTPROVIDETRADABLEBONUS: "DIRECTPROVIDETRADABLEBONUS",
};

export const MAMWALLET__MUTATIONS = {
  MANAGERSCOMMISSIONHISTORY: "MANAGERSCOMMISSIONHISTORY",
  // INVESTORSCOMMISSIONHISTORY: "INVESTORSCOMMISSIONHISTORY",
  WALLETTRX: "WALLETTRX",
  UPDATEWALLETWITHDRAW: "UPDATEWALLETWITHDRAW",
  MANAGERSWALLETINFO: "MANAGERSWALLETINFO",
  INVESTORSWALLETINFO: "INVESTORSWALLETINFO",
};